module.exports = __webpack_public_path__ + "static/media/hearts_9.0ca5a215.png";